import Vue from "vue";
import VueI18n from "vue-i18n";

// 组件多语言
import zhLocale from "view-design/dist/locale/zh-CN"; // 中
import enLocale from "view-design/dist/locale/en-US"; // 英
import trLocale from "view-design/dist/locale/zh-TW"; // 繁中
import az_locale from "./local/az_locale"; // 阿塞拜疆
import deLocale from "view-design/dist/locale/de-DE"; // 德
import esLocale from "view-design/dist/locale/es-ES"; // 西班牙
import frLocale from "view-design/dist/locale/fr-FR"; // 法
import itLocale from "view-design/dist/locale/it-IT"; // 意大利
import ruLocale from "view-design/dist/locale/ru-RU"; // 俄罗斯
import trqLocale from "view-design/dist/locale/tr-TR"; // 土耳其
import heLocale from "./local/he_locale"; // 希伯来
import viLocale from "view-design/dist/locale/vi-VN"; // 越南

// 主模块多语言
import zhCn from "./local/zh-CN";
import trCn from "./local/tr-CN";
import enUs from "./local/en-US";
import az from "./local/az";
import es from "./local/es";
import de from "./local/de";
import fr from "./local/fr";
import he from "./local/he";
import it from "./local/it";
import ru from "./local/ru";
import trq from "./local/trq";
import vi from "./local/vi";

// 地址簿模块多语言
import address from "./local/address_zh-CN"; // 简中
import address_trCN from "./local/address_tr-CN"; // 繁中
import address_en from "./local/address_en-US"; // 英
import address_az from "./local/address_az"; // 阿塞拜疆
import address_de from "./local/address_de"; // 德语
import address_es from "./local/address_es"; // 西班牙
import address_fr from "./local/address_fr"; // 法语
import address_he from "./local/address_he"; // 希伯来
import address_it from "./local/address_it"; // 意大利
import address_ru from "./local/address_ru"; // 俄罗斯
import address_trq from "./local/address_trq"; // 土耳其

Vue.use(VueI18n);
Vue.locale = () => {};
const messages = {
  zh_CN: Object.assign(zhCn, zhLocale, address),
  en_US: Object.assign(enUs, enLocale, address_en),
  zh_TW: Object.assign(trCn, trLocale, address_trCN),
  de: Object.assign(de, deLocale, address_de),
  es: Object.assign(es, esLocale, address_es),
  fr: Object.assign(fr, frLocale, address_fr),
  it: Object.assign(it, itLocale, address_it),
  he: Object.assign(he, heLocale, address_he),
  ru: Object.assign(ru, ruLocale, address_ru),
  az: Object.assign(az, az_locale, address_az),
  tur: Object.assign(trq, trqLocale, address_trq),
  vi: Object.assign(vi, viLocale),
};

let hashUrl = window.location.hash;
if (hashUrl.includes("lang=")) {
  let hashLang = hashUrl.split("lang=")[1];
  localStorage.setItem("language", hashLang);
}

const i18n = new VueI18n({
  locale:
    localStorage.getItem("language") ||
    process.env.VUE_APP_LANGUAGE_KEY ||
    "zh_CN", // set locale
  messages, // set locale messages
});

export default i18n;
